module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root #freeHostedGallery .Site_Page":{"requireResources":[{"value":function () {
return new fox.RSVP.Promise(function (resolve) {
require.ensure([], function () {
return resolve(require('../components/fhg')(fox));
});
});
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101010},"path":"@root #freeHostedGallery .Site_Page","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/fhg.opt
// module id = 651
// module chunks = 4